import { Component, Input } from "@angular/core";

@Component({
  selector: "icn-collapsible",
  templateUrl: "./collapsiblle.component.html",
  styleUrls: ["./collapsible.component.scss"],
})
export class CollapsibleComponent {
  @Input() label;

  isOpen = false;
}
